
import Vue from 'vue'
import { mapper } from '@/stores/store'
import gsap from 'gsap'

export default Vue.extend({
  name: 'ScidUser',
  computed: {
    ...mapper('user', ['username', 'profileImage', 'updatedProfileImage']),
    avatarStyle() {
      return {
        backgroundImage: 'url("' + this.avatar + '")',
      }
    },
    avatar(): string {
      return this.updatedProfileImage || this.profileImage
    },
  },
  methods: {
    animateAvatar() {
      if (this.$refs.avatar) {
        gsap.fromTo(
          this.$refs.avatar as any,
          { scale: 1 },
          { duration: 0.125, scale: 1.125, ease: 'power2.out' }
        )
        gsap.to(this.$refs.avatar as any, {
          duration: 1,
          delay: 0.125,
          scale: 1,
          ease: 'elastic.out(3, 0.425)',
        })
      }
    },
  },
  watch: {
    updatedProfileImage: function (newValue, oldValue) {
      ;(this as any).animateAvatar()
    },
  },
})
